// extracted by mini-css-extract-plugin
export default {"iconWrapper":"icon__iconWrapper","asPrefix":"icon__asPrefix","danger":"icon__danger","icon":"icon__icon","label":"icon__label","hover":"icon__hover"};